import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-5 mb-5" }

import SimpleForm from "@/components/SimpleForm.vue";
import { ref } from "vue";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import moment from "moment/moment";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { isDateInDST_US } from "@/core/plugins/TimerService";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewWithdrawalRequestModal',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {

const modalRef = ref();
const isLoading = ref(false);
const period = ref([undefined, undefined] as any);

const criteria = ref<any>({});

const formData = ref({
  name: "",
  type: ReportRequestTypes.Rebate,
  query: criteria.value,
});

const defaultTime = ref<[Date, Date]>([
  new Date(2000, 1, 1),
  new Date(2000, 2, 1),
]);

const submitRebateReportRequest = async () => {
  isLoading.value = true;
  const [from, to] = period.value;
  const isDST = isDateInDST_US();
  criteria.value.createdFrom = from
    ? moment(from).format(`YYYY-MM-DD[T]${isDST ? 21 : 22}:00:00.000[Z]`)
    : null;
  criteria.value.createdTo = to
    ? moment(to).format(`YYYY-MM-DD[T]${isDST ? 20 : 21}:59:59.000[Z]`)
    : null;

  try {
    await TenantGlobalService.createReportRequest(formData.value);
    MsgPrompt.success("New report request sent successfully").then(() => {
      modalRef.value?.hide();
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show: () => {
    modalRef.value?.show();
  },
  hide: () => {
    modalRef.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "New Withdrawal Report",
    "is-loading": isLoading.value,
    submit: submitRebateReportRequest,
    style: {"width":"400px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          "label-width": "70px",
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Name",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Period",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "w-250px",
                  modelValue: period.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((period).value = $event)),
                  type: "daterange",
                  "start-placeholder": _ctx.$t('fields.startDate'),
                  "end-placeholder": _ctx.$t('fields.endDate'),
                  "default-time": defaultTime.value
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "default-time"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})